import MetricEventTypes from "@Enums/MetricEventTypes";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import {
  faArrowsToEye,
  faBrain,
  faBullseye,
  faCalendar,
  faScaleBalanced,
  faStopwatch,
  IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";
import { faScanRate } from "@Resources/app/icons/metrics";

const getMetricIcon = (metricName: MetricEventTypes | MetricFilterTypes) => {
  const iconMap = new Map<MetricEventTypes | MetricFilterTypes, IconDefinition>([
    [MetricFilterTypes.BYB_IQ, faBrain],
    [MetricFilterTypes.GAMEPLAY_DURATION, faCalendar],
    [MetricEventTypes.SCAN_FREQUENCY, faScanRate],
    [MetricEventTypes.SCAN_TIMING, faStopwatch],
    [MetricEventTypes.AWARENESS, faBullseye],
    [MetricEventTypes.CRITICAL_SCAN, faArrowsToEye],
    [MetricEventTypes.DECISION, faScaleBalanced],
  ]);

  return iconMap.get(metricName) || faBrain;
};

export default getMetricIcon;
